import { useEffect, useState } from "react";
import Lottie from "react-lottie";
import Preloader from "src/components/Preloader";
import constants from "src/constants";

interface LottieImageInterface {
  src: string;
  width: number;
  height: number;
}

const LottieImage = ({ src, width, height }: LottieImageInterface) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    import(`src/icons/${src}.json`).then(setAnimationData);
  }, [src]);

  if (!animationData)
    return (
      <div>
        <Preloader />
      </div>
    );

  return (
    <Lottie
      options={{
        ...constants.Images.lottieDefaultOptions,
        animationData: animationData,
      }}
      width={width}
      height={height}
    />
  );
};

export default LottieImage;
